import { ReactNode } from "react";

export const BoxContainer = ({ children }: { children: ReactNode }) => (
 <div className="m-2 flex flex-col items-start justify-start gap-6">
  {children}
 </div>
);
